import running from "./assets/icons/running.png";
import sneakers from "./assets/icons/sneakers.png";
import sportchic from "./assets/icons/sportchic.png";
import football from "./assets/icons/football.png";
import boots_men from "./assets/icons/boots_men.png";
import boots_women from "./assets/icons/boots_women.png";
import sandals_men from "./assets/icons/sandals-men.png";
import sandals_women from "./assets/icons/sandals-women.png";
import hiking from "./assets/icons/hiking.png";
import formal from "./assets/icons/formal.png";
import casual_men from "./assets/icons/casual-men.png";
import casual_women from "./assets/icons/casual-women.png";
import slipper_men from "./assets/icons/slipper-men.png";
import slipper_women from "./assets/icons/slipper-women.png";
import highheels from "./assets/icons/high-heels.png";
import crocs from "./assets/icons/crocs.png";
import ballerine from "./assets/icons/ballerine.png";
import handbag from "./assets/icons/handbag.png";

export const categoryImages = {
  Men: [
    { category: "Running", image: running },
    { category: "Sneakers", image: sneakers },
    { category: "Sport Chic", image: sportchic },
    { category: "Casual", image: casual_men },
    { category: "Formal", image: formal },
    { category: "Football", image: football },
    { category: "Hiking", image: hiking },
    { category: "Boots", image: boots_men },
    { category: "Sandals", image: sandals_men },
    { category: "Crocs", image: crocs },
    { category: "Slipper", image: slipper_men },
  ],
  Women: [
    { category: "Hand Bag", image: handbag },
    { category: "Running", image: running },
    { category: "Sneakers", image: sneakers },
    { category: "High Heels", image: highheels },
    { category: "Ballerine", image: ballerine },
    { category: "Sandals", image: sandals_women },
    { category: "Boots", image: boots_women },
    { category: "Sport Chic", image: sportchic },
    { category: "Casual", image: casual_women },
    { category: "Crocs", image: crocs },
    { category: "Slipper", image: slipper_women },
  ],
  Boys: [
    { category: "Running", image: running },
    { category: "Sneakers", image: sneakers },
    { category: "Boots", image: boots_men },
    { category: "Sandals", image: sandals_men },
    { category: "Casual", image: casual_men },
    { category: "Crocs", image: crocs },
    { category: "Slipper", image: slipper_men },
  ],
  Girls: [
    { category: "Running", image: running },
    { category: "Sneakers", image: sneakers },
    { category: "Ballerine", image: ballerine },
    { category: "Boots", image: boots_women },
    { category: "Sandals", image: sandals_women },
    { category: "Casual", image: casual_women },
    { category: "Crocs", image: crocs },
    { category: "Slipper", image: slipper_women },
  ],
  "Boys & Girls": [
    { category: "Running" },
    { category: "Sneakers" },
    { category: "Boots" },
    { category: "Sandals" },
    { category: "Casual" },
    { category: "Crocs" },
    { category: "Slipper" },
  ],
};

export const genders = ["Men", "Women", "Boys", "Girls", "Boys & Girls"];

export const API_KEYS = [
  "7cf16d159244f1eb6bfc4b3ed09d2266",
  "859238ac9c85a99b3c6717b82b2cc6ec",
  "15979b6bf932d0a11d4ce14d477eff6b",
  "583c3ca05727ec9f4ae0c4bdcbc8409e",
  "a8d757ef6e7c6a1f7b4796779beb04b8",
  "c247495802963dd67e1ef7b368286d21",
];

export const PASSWORD =
  "$6$fwefhgwuwf874d84d5d4s84614s86d4dwa3sixosadmin$dhwqhdiuqdqw95dd4qwd";
